import { useNavigate } from 'react-router';
import { Button, Image, Text } from '@/components/base';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-svh w-full flex-col justify-center overflow-auto bg-revamp-cobalt-400 bg-[length:100vw_100vh] bg-fixed bg-center bg-no-repeat text-center">
      <Image src="/assets/images/mascots/mascot-404.png" alt="404" className="mx-auto max-w-[200px]" />
      <Text variant="6xl" className="font-semibold text-white">
        404
      </Text>
      <Text className="mt-2 text-white">ขออภัย ไม่พบหน้าที่คุณต้องการ</Text>
      <Button variant="solid" color="secondary" className="mx-auto my-16 w-fit px-20" onClick={() => navigate('/')}>
        กลับหน้าหลัก
      </Button>
    </div>
  );
};

export default NotFound;
